// extracted by mini-css-extract-plugin
export default {"section":"Instagram_section__+2uQQ","div":"Instagram_div__Q4AUn","btn":"Instagram_btn__jPn6u"};